import { useCurrency } from "../config/CurrencyContext";

export function useConvertPrice() {
    const { selectedCurrency, getExchangeRate, getShippingCharge, getPayableAmount, getAdditionalCharge, selectedCountry, selectedCurrencyRate } = useCurrency();

    const convert = (price) => {
        const rate = getExchangeRate(selectedCurrency);
        return Math.ceil(price * rate);
    };
    const customerPriceWithCharge = (selectedCurrency, amount) => {
        const additionalChargeWithAmount = getShippingCharge(selectedCurrency, amount);
        return additionalChargeWithAmount;
    };

    const payableAmount = (customerPrice, discountPercentage) => {
        const payablePrice = getPayableAmount(customerPrice, discountPercentage);
        return convert(payablePrice);
    }

    const additionalCharge = (selectedCurrency, amount) => {
        return getAdditionalCharge(selectedCurrency, amount)
    }

    return { convert, customerPriceWithCharge, payableAmount, additionalCharge, selectedCountry, selectedCurrency, selectedCurrencyRate };
}
